export default __webpack_public_path__ + "static/wide-image-becdb4c281c527b989315b2f7ce20378.png";